var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-form"},[_c('Form',{attrs:{"values":_vm.loginData.user.data,"loading":_vm.loading,"confirmedProfileChange":_vm.confirmedProfileChange},on:{"onSubscribeClick":_vm.onSubscribeClick}}),(_vm.error_message)?_c('div',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.error_message))]):_vm._e(),_c('ChangePassword')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }